<template>
    <v-container>
        <v-card v-if="isAdmin || isStaff">
            <v-card-title>
                Events
                <v-spacer></v-spacer>
                <v-text-field label="search" v-model="search" prepend-icon="search"></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-btn color="success" @click="showEventForm=!showEventForm" v-if="isAdmin">New Event</v-btn>
                <v-data-table :headers="headers" :items="events" :search="search" :loading="loading">
                    <template v-slot:item.actions="{ item }">
                        <v-btn color="warning" @click="viewRegistrations(item)" class="mr-1 mb-1 mt-1" v-if="isAdmin">
                            Registrations</v-btn>
                        <v-btn color="success" @click="viewCheckins(item)" class="mr-1 mb-1 mt-1">Check-Ins</v-btn>
                        <v-btn color="primary" @click="editEvent(item)" class="mr-1 mb-1 mt-1" v-if="isAdmin">Edit
                        </v-btn>
                        <v-btn color="error" @click="deleteEvent(item)" class="mr-1 mb-1 mt-1" v-if="isAdmin">Delete
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="showcheckins" persistent>
            <event-checkins :event_obj="selectedEvent" @close_checkings="showcheckins=!showcheckins"></event-checkins>
        </v-dialog>

        <v-dialog v-model="showRegistrations" persistent>
            <event-registration-list :event_obj="selectedEvent"
                @close_registrations="showRegistrations=!showRegistrations"></event-registration-list>
        </v-dialog>

        <v-dialog v-model="showEventForm" persistent max-width="500px">
            <v-form ref="eventForm">
                <v-card>
                    <v-card-title>{{editedIndex==-1?'Add':'Edit'}} Event</v-card-title>
                    <v-card-text>

                        <v-text-field label="Title*" v-model="new_event_data.title" :rules="[rules.required]">
                        </v-text-field>
                        <v-textarea label="Description*" v-model="new_event_data.description" :rules="[rules.required]">
                        </v-textarea>
                        <v-text-field v-model="dateRangeText" label="Event Date *" readonly
                            @click="showEventDatePicker=!showEventDatePicker" :rules="[rules.required]">
                        </v-text-field>
                        <v-dialog v-model="showEventDatePicker" max-width="400px">
                            <v-card>
                                <v-card-title>
                                    Select Event Start -> End Date
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="showEventDatePicker=!showEventDatePicker">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-date-picker v-model="new_event_data.event_date" range full-width
                                        :rules="[rules.required]">
                                    </v-date-picker>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="showEventDatePicker=!showEventDatePicker" color="success">select
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-text-field label="Location*" v-model="new_event_data.location" :rules="[rules.required]">
                        </v-text-field>
                        <v-select :items="event_status_list" label="Status" v-model="new_event_data.status"></v-select>
                        <v-text-field label="Cover Image Link*" v-model="new_event_data.cover_img"
                            :rules="[rules.required]">
                        </v-text-field>
                        <v-text-field label="Live Link" v-model="new_event_data.live_link"></v-text-field>
                        <v-text-field label="Event Calendar Link" v-model="new_event_data.cal_link"></v-text-field>
                        <v-select label="Approval Type:" :items="approval_types" v-model="new_event_data.approv_type">
                        </v-select>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="saveEvent()" :loading="loading">save</v-btn>
                            <v-btn color="error" @click="showEventForm=!showEventForm">close</v-btn>
                        </v-card-actions>


                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
    </v-container>
</template>

<script>
import EventCheckins from './EventCheckins.vue';
import EventRegistrationList from './EventRegistrationList.vue';
import eventService from '@/services/event.service'
import { db } from '@/config/firebasedb';
export default {
    components: {
        EventCheckins,
        EventRegistrationList
    },
    data: () => ({
        showcheckins: false,
        showRegistrations: false,
        showEventForm: false,
        showEventDatePicker: false,
        loading: false,
        isAdmin: false,
        isStaff: false,
        adminCodes: ['872372', '691249', '172198'],
        staffCodes: ['347222', '459328', '753038'],
        search: '',
        selectedEvent: null,
        editedIndex: -1,
        lastDeletedIndex: -1,
        dates: ['', ''],
        event_status_list: ['upcoming', 'ongoing', 'completed'],
        approval_types: ['auto', 'manual'],
        new_event_data: {
            title: "",
            description: "",
            from_date: "",
            to_date: "",
            event_date: [],
            location: "online",
            cover_img: "",
            status: "upcoming",
            approv_type: "",
            live_link: "",
            cal_link: "",
        },
        new_event_datacp: {
            title: "",
            description: "",
            from_date: "",
            to_date: "",
            event_date: [],
            location: "online",
            cover_img: "",
            status: "upcoming",
            approv_type: "auto",
            live_link: "",
            cal_link: "",
        },
        rules: {
            required: value => !!value || 'Required.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        },
        headers: [
            {
                text: 'Title',
                align: 'start',
                sortable: false,
                value: 'title',
            },
            { text: 'Description', value: 'description' },
            { text: 'Start Date', value: 'from_date' },
            { text: 'End Date', value: 'to_date' },
            { text: 'Location', value: 'location' },
            { text: 'Status', value: 'status' },
            { text: 'Actions', value: 'actions' },
        ],
        events: []
    }),
    async created() {
        if (this.$route.params.role_id) {
           this.isAdmin = await this.adminCodes.includes(this.$route.params.role_id)
           this.isStaff = await this.staffCodes.includes(this.$route.params.role_id)
            this.loading = true;
            var eventsRef = db.collection("events")
            await eventsRef.onSnapshot(snap => {
                this.events = []
                snap.forEach((doc) => {
                    var event = doc.data();
                    event.id = doc.id;
                    event.from_date = event?.event_date[0];
                    event.to_date = event?.event_date[1];
                    this.events.unshift(event);

                });
                this.loading = false;
            });
        }



    },
    methods: {
        viewRegistrations(event_obj) {
            this.selectedEvent = event_obj
            this.showRegistrations = true
        },
        viewCheckins(event_obj) {
            this.selectedEvent = event_obj
            this.showcheckins = true;
        },
        async addEvent() {
            if (!this.$refs.eventForm.validate()) {
                return
            }
            this.loading = true;
            await eventService.addEvent(this.new_event_data).then(() => {
                this.loading = false
                this.$toast.success("Event added successfully")
                Object.assign(this.new_event_data, this.new_event_datacp)
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$toast.error("An error occured and events could not be loaded")
            })
        },
        editEvent(event_obj) {
            this.editedIndex = this.events.indexOf(event_obj);
            Object.assign(this.new_event_data, event_obj)
            this.showEventForm = true;
        },
        async deleteEvent(event_obj) {

            if (confirm("Deleting this event will also delete all associated registrations and itineries. Are you sure you want to proceed?")) {
                await db.collection('events').doc(event_obj.id).delete().then(() => {
                    this.$toast.success("Event deleted successfully")
                }).catch(err => {
                    console.log(err)
                    this.loading = false
                    this.$toast.error("An error occured and events could not be deleted")
                });
            }
        },
        async updateEvent() {
            this.loading = true;
            delete this.new_event_data.from_date
            delete this.new_event_data.to_date
            await db.collection("events").doc(this.new_event_data.id).update(this.new_event_data).then(() => {
                this.$toast.success("Event updated successfully")
                this.showEventForm = false
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$toast.error("An error occured and events could not be updated")
            });
            this.loading = false
            this.showEventForm = false
        },
        saveEvent() {
            if (this.editedIndex < 0) {
                this.addEvent()
            } else {
                this.updateEvent()
            }
        }

    },
    computed: {
        dateRangeText() {
            return this.new_event_data.event_date.join(' ~ ')
        }
    },
    watch: {
        showEventForm(value) {
            if (!value) {
                Object.assign(this.new_event_data, this.new_event_datacp)
                this.editedIndex = -1;
            }
        }
    }
}
</script>